export async function getCheckoutHash(firstName, lastName) {
  if (!firstName || !lastName) {
    return null
  }

  const encoder = new TextEncoder()
  const data = encoder.encode(`${firstName.trim().toLowerCase()}|${lastName.trim().toLowerCase()}`)
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}
